import { createAction } from '@reduxjs/toolkit';

export const spotifyApiPending = createAction('spotifyApi/pending');
export const spotifyApiFulfilled = createAction('spotifyApi/fulfilled');
export const spotifyApiRejected = createAction('spotifyApi/rejected');
